import React from 'react';

export interface IBenefitsRatingItem {
  icon: string;
  title: string;
  link?: string;
}

export interface IBenefitsSectionRatingsProps {
  items: IBenefitsRatingItem[];
}
export default function BenefitsSectionRatings({ items }: IBenefitsSectionRatingsProps) {
  return (
    <div className="benefits-section__ratings">
      {items.map(({ icon, title, link }, idx) => {
        const image = <img src={icon} alt={title} loading="lazy" />;

        return (
          <div key={`${title}-${idx}`} className="benefits-section__ratings__item">
            <div className="benefits-section__ratings__item__logo">
              {link ? (
                <a href={link} target="_blank" rel="noopener noreferrer" aria-label={title}>
                  {image}
                </a>
              ) : (
                image
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
